(function () {
  'use strict';

  angular.module('clientDashboardApp.admin.groups', [
    'clientDashboardApp.admin.groups.groupsService',
    'clientDashboardApp.admin.accounts.groups.groupEditor'
  ]).controller("GroupsManagerCtrl", GroupsManagerCtrl);

  GroupsManagerCtrl.$inject = ['$scope', '$state', '$location', 'accountId', 'groupsService', 'pagingService', 'locationGroupService', 'updateService','adminSearchService','stringService'];
  function GroupsManagerCtrl($scope, $state, $location, accountId, groupsService, pagingService, locationGroupService, updateService, adminSearchService, stringService) {
    var vm = this;

    vm.groupSearchQuery = adminSearchService.getSearchQuery();
    vm.accountSelected = false;
    vm.totalGroupsInResponse = null;
    vm.loadingGroups = true;
    vm.freshQuery = null;
    vm.groupExportConfig = {};
    vm.accountConfig = {
      required : false,
      accountId : null,
      disableDropdown: false,
      showAccountSelection: true
    }

    vm.state = {
      updating: false
    }

    vm.pageStrings = stringService.adminStrings();

    vm.updateConfig = {
      entityId : null,
      pageOneResult : true
    }

    vm.refreshGroups = function () {
      vm.groupSearchQuery = adminSearchService.getSearchQuery();
      vm.freshQuery = vm.groupSearchQuery;
      var accountIdToPass = vm.accountConfig.accountId == "all" ? undefined : vm.accountConfig.accountId;
      vm.loadingGroups = true;
      groupsService.listGroups(accountIdToPass, vm.groupSearchQuery).then(function (resp) {
        var groups = resp.groups;
        vm.totalGroupsInResponse = groups.length;

        vm.groupsPaged = pagingService.createPagingData(groups, 15, 'groupName');
        if(pagingService.getCurrentPage()){
          vm.groupsPaged.currentPageNum = pagingService.getCurrentPage();
        }
        vm.loadingGroups = false;

        if(vm.updateConfig.entityId){
          if(_.where(vm.groupsPaged.pagedItems[0],{id:vm.updateConfig.entityId}).length>0){
            vm.updateConfig.pageOneResult = true;
          }
        }
      });

      vm.groupExportConfig = {
        export: function () {
          return groupsService.exportGroups(accountIdToPass, vm.groupSearchQuery);
        },
        accountId: accountIdToPass,
        groupSearchQuery: vm.groupSearchQuery
      };

      locationGroupService.getLocationGroups().then(function(groupResults){
        vm.defaultLBVReportId = groupResults.data.defaultLBVReportId;
      });
    };

    vm.updatePagingState = function(){
      pagingService.setCurrentPage(vm.groupsPaged.currentPageNum);
    }

    vm.openConfirmDeleteGroupModal = function (group) {
      vm.group = angular.copy(group);
      $('#confirmDeleteGroupModal').modal();
    };

    vm.updateGroup = function () {
      vm.updateErrorMsg = '';
      vm.loadingGroups = true;
      groupsService.updateGroup(vm.groupEditor.group).then(function () {
        //Group successfully updated
      }, function updateError() {
        vm.updateErrorMsg = 'An error occurred while updating group: ' + vm.accountEditor.originalGroup.groupName +
        ' to ' + vm.accountEditor.group.groupName + '!';
      }).then(vm.refreshGroups);
    };

    vm.searchForUpdatedGroup = function(){
      vm.groupSearchQuery = vm.updateDetails.searchParam;
      updateService.resetUpdateStatus();
      vm.refreshGroups();
    }

    vm.deleteGroup = function (group) {
      vm.state.updating = true;
      groupsService.deleteGroup(group).then(function () {
        var updateInfo = {
          status: "Active",
          type: "group",
          title: "Group",
          destinationRole: "manage",
          notificationType: "detail",
          actions: [{action:"delete"}],
          entity: vm.group,
          id: vm.group.id,
          name: vm.group.groupName,
          searchParam: vm.group.groupName
        }
        updateService.registerSuccessfulUpdate(updateInfo);
        $state.reload();
        /* Hack to fix issue with modal not fully closing: https://stackoverflow.com/questions/22056147/bootstrap-modal-backdrop-remaining
         * I think this is an issue with the Angular state reloading, but I didn't want to sink more time into it and because bootstrap closes the modal
         * asynchronously it's hard to replicate, hence the hack. */
        $('.modal-backdrop').remove();
      },function(){
        vm.state.updating = false;
      });
    };

    vm.gotoGroupEditor = function(opType,group){
      if(opType=="create"){
        $location.path("admin/v2/groups/create");
      }
      else if(opType=="edit"){
        $location.path("admin/v2/groups/"+group.id+"/edit");
      }
    }

    vm.isUpdatedItemRow = function(id,entityId){
      return id==entityId;
    }

    $scope.$watch('vm.accountConfig.accountId',function(newVal,oldVal) {
      if(oldVal !== newVal) {
        vm.refreshGroups();
      }
    });
  }
})();
